const Actions = {
  SET_ANALYTICS_CONFIG: "YouVisitAnalytics.Actions.SET_ANALYTICS_CONFIG",
  SET_IS_REGISTERED: "YouVisitAnalytics.Actions.SET_IS_REGISTERED",
  SET_PERSONALIZATION_ENABLED:
    "YouVisitAnalytics.Actions.SET_PERSONALIZATION_ENABLED",
  SET_EXPERIENCE_OFFLINE: "YouVisitAnalytics.Actions.SET_EXPERIENCE_OFFLINE",
  SET_EXPERIENCE_NOT_FOUND:
    "YouVisitAnalytics.Actions.SET_EXPERIENCE_NOT_FOUND",
};

export default Actions;
